import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";


import Login from "./login/Login";

  import ForgotPassword from "./login/ForgotPassword";
  import ResetPassword from "./login/ResetPassword";
  import InvalidToken from "./login/InvalidToken";

  // import RegisterA from "./register/RegisterA";
  // import RegisterB from "./register/RegisterB";
  // import RegisterC from "./register/RegisterC";
  // import RegisterD from "./register/RegisterD";
  // import RegisterE from "./register/RegisterE";
  
  import Accounts from "./accounts/Accounts";
  import AccountCategory from "./accounts/AccountCategory";
  import AccountDetailPage from "./accounts/AccountDetailPage";

  import ActivityTypeList from "./activities/ActivityTypeList";

  import Dashboard from "./common/Dashboard";
  import Reports from "./reports/Reports";
  ///import Brands from "./brands/Brands";

  import Leads from "./leads/Leads";
  import LeadsKanban from "./leads/LeadsKanban";
  ///import OrdersCalendar from "./leads/OrdersCalendar";

  import LeadSources from "./leads/LeadSources";
  import LeadChannels from "./leads/LeadChannels";
  import LeadTypes from "./leads/LeadTypes";
  import LeadStatus from "./leads/LeadStatus";
  import LeadTags from "./leads/LeadTags";
  import LeadLossReason from "./leads/LeadLossReason";
  import LeadIndustry from "./leads/LeadIndustry";
  
  import ActivitiesPage from "./activities/ActivitiesPage";
  import ActivitiesReport from "./activities/ActivitiesReport";
  
  import PaymentModes from "./payments/PaymentModes";
  import PaymentBanks from "./payments/PaymentBanks";
  
  import ContactsList from "./contacts/ContactsList";
  
  import CampaignsList from "./campaigns/CampaignsList";
  ///import TechniciansList from "./technicians/TechniciansList";
  // import ServiceCards from "./servicecards/ServiceCards";
  // import ServiceCardTypes from "./servicecards/ServiceCardTypes";
  // import ServiceTypes from "./services/ServiceTypes";
  // import Services from "./services/Services";
  // import ServicePackageTypes from "./services/ServicePackageTypes";
  // import ServicePackages from "./services/ServicePackages";
  // import CityList from "./city/CityList";
  // import ServiceCategoryList from "./services/ServiceCategoryList";
  // import ServiceProductsList from "./services/ServiceProductsList";
  import SmsTemplates from "./sms/SmsTemplates";
  import SmsApi from "./sms/SmsApi";
  import AgentsList from "./agents/AgentsList";
  import ChangePassword from "./common/ChangePassword";
  import Invoices from "./invoices/Invoices";
  import InvoicesTypes from "./invoices/InvoicesTypes";
  import InvoiceSetting from "./invoices/InvoiceSetting";
  import Roles from "./roles/Roles";
  import SettingMaster from "./common/SettingMaster";  
  import Visibility from "./common/Visibility";

  import KeywordList from "./keywords/KeywordList";
  import KeywordsTreeview from "./keywords/KeywordsTreeview";
  import KeywordsTreeList from "./keywords/KeywordsTreeList";
  import FreeProductsList from "./free_company/FreeProductsList";
  import FreeCompanyList from "./free_company/FreeCompanyList";
  
  
// const getBasename = () => {
//   ///return '/'+process.env.PUBLIC_URL.split('/').pop();
//   ///return "/reacteasetolearn";
//   return "";
// };

function App() {

  return (
    <Router basename={""} >
      <div>
        
        <Routes> 
        
          <Route exact path="keywords" element={<KeywordList/>} />
          <Route exact path="keywords-treeview" element={<KeywordsTreeview/>} />
          <Route exact path="free-company" element={<FreeCompanyList/>} />
          <Route exact path="free-products" element={<FreeProductsList/>} />
          <Route exact path="keywords-tree-list" element={<KeywordsTreeList/>} />

          
          <Route exact path="dashboard" element={<Dashboard/>} />
          <Route exact path="reports" element={<Reports/>} />
          <Route exact path="leads" element={<Leads/>} />
          <Route exact path="leadskanban" element={<LeadsKanban/>} />
          {/* <Route exact path="orderscalendar" element={<OrdersCalendar/>} /> */}

          <Route exact path="activities" element={<ActivitiesPage/>} />
          <Route exact path="activities-report" element={<ActivitiesReport/>} />

          
          <Route exact path="lead-channels" element={<LeadChannels/>} />
          <Route exact path="lead-status" element={<LeadStatus/>} />
          <Route exact path="lead-types" element={<LeadTypes/>} />
          <Route exact path="lead-sources" element={<LeadSources/>} />
          <Route exact path="lead-industry" element={<LeadIndustry/>} />
          <Route exact path="lead-tags" element={<LeadTags/>} />
          <Route exact path="lead-loss-reason" element={<LeadLossReason/>} />
                    
          <Route exact path="contacts" element={<ContactsList/>} /> 
          <Route exact path="accountdetail" element={<AccountDetailPage/>} />
          <Route exact path="accounts" element={<Accounts/>} />
          <Route exact path="account-category" element={<AccountCategory/>} />
          {/* <Route exact path="technicians" element={<TechniciansList/>} /> */}

          <Route exact path="payment-modes" element={<PaymentModes/>} />
          <Route exact path="payment-banks" element={<PaymentBanks/>} />

          <Route exact path="campaigns" element={<CampaignsList/>} /> 
          
          <Route exact path="payment-modes" element={<PaymentModes/>} />
          <Route exact path="payment-banks" element={<PaymentBanks/>} />

          {/* <Route exact path="subscriptions" element={<ServiceCards/>} />
          <Route exact path="servicecard-types" element={<ServiceCardTypes/>} />
          <Route exact path="service-types" element={<ServiceTypes/>} />
          <Route exact path="services" element={<Services/>} />
          <Route exact path="service-package-types" element={<ServicePackageTypes/>} />
          <Route exact path="service-packages" element={<ServicePackages/>} />
          <Route exact path="city-list" element={<CityList/>} />
          <Route exact path="service-category-list" element={<ServiceCategoryList/>} />
          <Route exact path="service-products" element={<ServiceProductsList/>} /> */}
          <Route exact path="sms-templates" element={<SmsTemplates/>} />

          
          <Route exact path="activity-types" element={<ActivityTypeList/>} /> 
          <Route exact path="agents" element={<AgentsList/>} />
          <Route exact path="invoices" element={<Invoices/>} />
          <Route exact path="invoices-types" element={<InvoicesTypes/>} />
          <Route exact path="invoices-setting" element={<InvoiceSetting/>} />
          <Route exact path="roles" element={<Roles/>} />
          <Route exact path="setting-master" element={<SettingMaster/>} />
          <Route exact path="sms-api" element={<SmsApi/>} />
          <Route exact path="visibility" element={<Visibility/>} />
                    
          <Route exact path="change-password" element={<ChangePassword/>} />

          {/* <Route exact path="create-account" element={<RegisterA/>} />
          <Route exact path="verify-mobile" element={<RegisterB/>} />
          <Route exact path="enter-email" element={<RegisterC/>} />
          <Route exact path="verify-email" element={<RegisterD/>} />
          <Route exact path="create-password" element={<RegisterE/>} /> */}

          <Route exact path="forgotpassword" element={<ForgotPassword/>} />
          <Route exact path="resetpassword" element={<ResetPassword/>} />  

          <Route exact path="invalidtoken" element={<InvalidToken/>} /> 
          <Route exact path="login" element={<Login />} />  
          <Route exact path="/" element={<Login />} />  
          
          
        </Routes>
      </div>
    </Router>
  );
}

export default App;
